<template>
  <section v-loading="loading" class="selected-test-preview" :class="{ testsPreviewView: caseId }"
    id="blood-panel-test-preview">
    <el-tabs class="icons-close">
      <el-tab-pane>
        <template #label>
          <h3 style="
              color: #f24a58;
              margin: 0 0 5px 0;
              font-size: 14px;
              font-weight: 500;
              text-decoration: underline;
              text-align: left;
              line-height: 1.3;
              cursor: default;
            ">
            Tests & Panels
          </h3>

          <!-- All Panels Group -->
          <div class="panels-group">
            <!-- 1. All Tests Panels  -->

           
            <div class="view-blood-tests" v-for="(category, index) of getCaseCategoryData(
              test.case_type_code
            )" :key="index">
              <div class="inside">
                <div class="view-custom-tabs-label">
                  <ul class="check-list-woundpanel" id="panels" v-if="category && category.panel_code == 'ALL_TESTS'">

                    
                   
                    <li v-for="(item, index) of sortedCategoryWiseTestsData(
                      category
                    )" :key="index">
                      <el-checkbox-group v-model="panelsTestsData.selectedTestIds">
                        <el-checkbox :label="item._id" :value="item" disabled>
                          <span class="ellipse">
                            {{ item.test_name }}
                          </span>
                          <el-button class="test-close-button" @click="removeTest(item, category.panel_id)"
                            v-if="notCreateCase" :disabled="hasCases">
                            <img src="@/assets/images/fax-tag-close.svg" alt="icon" width="30" />
                          </el-button>
                        </el-checkbox>
                      </el-checkbox-group>
                    </li>
                  </ul>
                  <ul class="check-list-woundpanel" id="panels" v-if="
                    category &&
                    category.panel_code !== 'ALL_TESTS' &&
                    category &&
                    category.panel_code !== 'SEND_OUTS'
                  ">
                    <li>
                      <span class="test" @click="showBloodTests(category)">{{
                        category.panel_title
                      }}</span>

                      <el-button class="test-close-button" @click="removeCategory(category)" v-if="notCreateCase"
                        :disabled="hasCases">
                        <img src="@/assets/images/fax-tag-close.svg" alt="icon" width="30" />
                      </el-button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <!--2. Allergy panel -->
            <div class="view-blood-tests">
              <div class="view-custom-tabs-label">
                <div class="inside" v-if="showTab('CLINICAL_CHEMISTRY', ['ALLERGY_TEST_PANEL'])">
                  <ul class="check-list-woundpanel" id="panels">
                    <li>
                      <span @click="showAllergyTests">
                        Allergy Test Panel
                      </span>
                      <el-button class="test-close-button" @click="removeTab" v-if="notCreateCase" :disabled="hasCases">
                        <img src="@/assets/images/fax-tag-close.svg" alt="icon" width="30" />
                      </el-button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <!-- All SendOut Panel Group -->
          <div class="view-blood-tests" v-for="(category, index) of getCaseCategoryData(
            test.case_type_code
          )" :key="index">
            <div class="inside">
              <div class="view-custom-tabs-label">
                <ul id="sendout-tests" class="check-list-woundpanel sendouts"
                  v-if="category && category.panel_code == 'SEND_OUTS'">
                  <li v-for="(item, index) of sortedCategoryWiseTestsData(
                    category
                  )" :key="index">
                    <el-checkbox-group v-model="panelsTestsData.selectedTestIds">
                      <el-checkbox :label="item._id" :value="item" disabled>
                        <span class="ellipse">
                          {{ item.test_name }}
                        </span>
                        <el-button class="test-close-button" @click="removeTest(item, category.panel_id)"
                          v-if="notCreateCase" :disabled="hasCases">
                          <img src="@/assets/images/fax-tag-close.svg" alt="icon" width="30" />
                        </el-button>
                      </el-checkbox>
                    </el-checkbox-group>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </template>
      </el-tab-pane>
    </el-tabs>
    <div class="default-modal" v-if="allergyTestsPopup">
      <el-dialog v-model="allergyTestsPopup">
        <div class="dialog-header">
          <span class="header-part"> Allergy Test Panel </span>
          <el-button size="medium" class="el-white" type="info" plain @click="allergyTestsPopup = false">
            <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon" /></el-button>
        </div>
        <div class="popup-panels-blocks">
          <ul>
            <li class="toxicology-text-panels" v-for="(category, index) of getCaseCategoryBasedData(
              test.case_type_code,
              ['ALLERGY_TEST_PANEL']
            )" :key="index">
              <h3 class="test-group-title">{{ category.panel_title }}</h3>
              <ul class="check-list-gastro">
                <li v-for="(item, index) of sortedCategoryWiseTestsData(category)" :key="index">
                  <el-checkbox-group v-model="panelsTestsData.selectedTestIds">
                    <el-checkbox :label="item._id" :value="item" disabled>{{
                      item.test_name
                    }}</el-checkbox>
                  </el-checkbox-group>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </el-dialog>
    </div>
    <div class="default-modal" v-if="bloodTestsPopup && this.bloodTestdata">
      <el-dialog v-model="bloodTestsPopup">
        <div class="dialog-header">
          <span class="header-part">
            {{ this.bloodTestdata.panel_title }}
          </span>
          <el-button size="medium" class="el-white" type="info" plain @click="bloodTestsPopup = false">
            <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon" /></el-button>
        </div>
        <div class="popup-panels-blocks">
          <ul class="check-list-gastro">
            <li v-for="(item, index) of sortedCategoryWiseTestsData(
              this.bloodTestdata
            )" :key="index">
              <el-checkbox-group v-model="panelsTestsData.selectedTestIds">
                <el-checkbox :label="item._id" :value="item" disabled>{{
                  item.test_name
                }}</el-checkbox>
              </el-checkbox-group>
            </li>
          </ul>
        </div>
      </el-dialog>
    </div>
  </section>
</template>

<script>
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import AppHelper from "@/mixins/AppHelper";

import { mapGetters } from "vuex";

export default {
  mixins: [UserPermissionsHelper, AppHelper],
  components: {},
  props: ["panelTestsData", "test", "allSelectedTests", "newCase"],

  data() {
    return {
      activeNameCollapse: "",
      testsData: [],
      existed: [],
      panelsTestsData: {
        selectedTestIds: [],
        selectedCoriellPanels: [],
        selectedCategories: [],
        selectedGroup: []
      },
      allTests: "",
      loading: false,
      caseRouteNames: [
        "NewCase",
        "Case-Information-Update",
        "NewOrder",
        "Edit-Order-Info",
        "PendingCasesEdit",
        "Concurrent-Case-Information-Update",
      ],
      allergyTestsPopup: false,
      bloodTestsPopup: false,
      bloodTestdata: {},
      isCaseView: ["CaseView"],
    };
  },
  async mounted() {
    this.panelsTestsData = this.panelTestsData;

    this.allTests = this.allSelectedTests;
    this.loading = true;
    this.loading = false;
  },
  computed: {
    ...mapGetters("auth", ["getAuthenticatedUser", "getUserPrimaryLabId"]),
    ...mapGetters("labTests", [
      "getAllLabTests",
      "getNewLabGroupWiseTests",
      "getNewLabGroupPanelTests",
    ]),
    hasCases() {
      if (this.checkUser && !this.hasAllowedCaseType && !this.newCase) {
        return true;
      } else if (this.checkUser && this.hasAllowedCaseType && this.newCase) {
        return true;
      }
      return false;
    },
    checkUser() {
      if (
        this.getAuthenticatedUser &&
        this.getAuthenticatedUser.user_type == "LAB_TECHNOLOGIST"
      ) {
        return true;
      }
      return false;
    },
    hasAllowedCaseType() {
      if (
        this.getAuthenticatedUser.allowed_case_types &&
        this.getAuthenticatedUser.allowed_case_types.length
      ) {
        if (
          this.getCaseInformation &&
          this.getCaseInformation.case_types &&
          this.getCaseInformation.case_types.length
        ) {
          const cases = this.getCaseInformation.case_types;
          const casetypes = this.getAuthenticatedUser.allowed_case_types;

          if (cases.every((item) => casetypes.includes(item))) {
            return true;
          } else {
            return false;
          }
        }
      }
      return false;
    },
    notCreateCase() {
      if (this.caseRouteNames.indexOf(this.$route.name) != -1) {
        return true;
      }
      return false;
    },
    getTestsInformationObject() {
      const obj = {};
      if (this.allTests) {
        this.allTests.forEach((el) => {
          obj[el._id] = el;
        });
      }
      return obj;
    },
    selectedTestsDetails() {
      const data = [];
      if (this.panelsTestsData.selectedTestIds) {
        this.panelsTestsData.selectedTestIds.forEach((el) => {
          if (el && this.getTestsInformationObject[el]) {
            data.push(this.getTestsInformationObject[el]);
          }
        });
      }

      return data;
    },
    isEdit() {
      if (this.$route.query.edit) {
        return true;
      } else if (
        !this.getCaseInformation ||
        !this.getCaseInformation.tests_info ||
        this.getCaseInformation.tests_info.length === 0
      ) {
        return true;
      }
      return false;
    },
    caseId() {
      if (this.isCaseView.indexOf(this.$route.name) != -1) {
        return true;
      }
      return false;
    },
  },
  methods: {
    sortedCategoryWiseTestsData(category) {
      let selectedCategory = this.panelsTestsData.selectedCategories.find(
        (e) => e.panel_id == category.panel_id && e.case_type_code == category.case_type_code
      );

      if (!selectedCategory) {
        return [];
      }

      return this.getCategoryWiseTestsData(
        category.case_type_code,
        category.panel_code
      )
        .filter((test) => selectedCategory.test_ids.includes(test._id))
        .sort((a, b) => {
          return a.test_name.localeCompare(b.test_name);
        });
    },
    showAllergyTests() {
      this.allergyTestsPopup = true;
    },
    showBloodTests(category) {
      this.bloodTestdata = category;
      this.bloodTestsPopup = true;
    },
    removeTab() {
      let panel = ["ALLERGY_TEST_PANEL"];

      this.$confirm(
        `Are you sure want to remove this
        <br/>
        <b style="color:#0A5DA6">"ALLERGY TEST PANEL"</b> test type ?`,
        "Warning",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      ).then(() => {
        for (var i = 0; i < this.allTests.length; i++) {
          var obj = this.allTests[i];

          if (panel.indexOf(obj.parent_category_code) !== -1) {
            this.allTests.splice(i, 1);
            i--;
          }
        }
      });
    },
    removeTest(test, panel_id) {
      let testName = test.test_name.split("_").join(" ");
      this.$confirm(
        `Are you sure want to remove this
        <br/>
        <b style="color:#0A5DA6">"${testName}"</b> test type ?`,
        "Warning",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      ).then(() => {
        let index = this.panelsTestsData.selectedCategories.findIndex(
          (e) => e.panel_id == panel_id
        );
        if (index > -1) {
          let testIndex = this.panelsTestsData.selectedCategories[
            index
          ].test_ids.indexOf(test._id);

          this.panelsTestsData.selectedCategories[index].test_ids.splice(
            testIndex,
            1
          );

          if (this.panelsTestsData.selectedCategories[index].test_ids.length == 0) {
            this.panelsTestsData.selectedCategories.splice(index, 1)
          }
        }
      });
    },
    removeCategory(category) {
      let testName = category.panel_title;
      this.$confirm(
        `Are you sure want to remove this
        <br/>
        <b style="color:#0A5DA6">"${testName}"</b> test type ?`,
        "Warning",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      ).then(() => {
        let index = this.panelsTestsData.selectedCategories.findIndex(
          (e) => e.panel_id == category.panel_id
        );
        if (index > -1) {
          this.panelsTestsData.selectedCategories.splice(index, 1);
        }
      });
    },
    getCategoryWiseTestsData(caseType, category) {

      const data = this.getNewLabGroupPanelTests.filter(
        (el) => el.case_type_code === caseType && el.panel_code === category
      );
      return data;
    },
    getCaseCategoryData(caseType) {
      let selectedTestPanelIds = this.panelsTestsData.selectedCategories.filter((e)=> e.case_type_code == caseType).map(
        (e) => e.panel_id
      );

      let data = this.getNewLabGroupPanelTests.filter((e) => selectedTestPanelIds.includes(e.panel_id) && e.case_type_code == caseType);

      return data.reduce((acc, current) => {
        const x = acc.find((item) => item.panel_id == current.panel_id);
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
      }, []);
    },
    showTab(caseType, category, include = true) {
      if (include) {
        return this.selectedTestsDetails.filter(
          (el) =>
            el.case_type_code === caseType &&
            category.indexOf(el.parent_category_code) != -1
        ).length
          ? true
          : false;
      } else {
        return this.selectedTestsDetails.filter(
          (el) =>
            el.case_type_code === caseType &&
            category.indexOf(el.panel_code) == -1
        ).length
          ? true
          : false;
      }
    },
    getCaseCategoryBasedData(caseType, category, include = true) {
      let data = "";
      if (include) {
        data = this.selectedTestsDetails.filter(
          (el) =>
            el.case_type_code === caseType &&
            category.indexOf(el.parent_category_code) != -1
        );
      } else {
        data = this.selectedTestsDetails.filter(
          (el) =>
            el.case_type_code === caseType &&
            category.indexOf(el.panel_code) == -1
        );
      }

      let flags = [],
        output = [],
        outputWithFullDetails = [],
        l = data.length,
        i;
      for (i = 0; i < l; i++) {
        if (flags[data[i].panel_code]) continue;
        flags[data[i].panel_code] = true;
        output.push(data[i].panel_code);
        outputWithFullDetails.push(data[i]);
      }
      return outputWithFullDetails;
    },
  },
};
</script>
<style lang="scss">
#blood-panel-test-preview {
  .test-panels-blocks {
    .toxicology-text-panels {
      padding: 10px 0;
      position: relative;
    }

    .toxicology-text-panels:not(:last-child):after {
      content: "";
      position: absolute;
      width: 100%;
      left: 0;
      bottom: 0;
      border-bottom: 1px solid #e8e4e4;
    }

    .check-list-toxicology {
      display: grid;
      grid-template-columns: repeat(5, 19%);
      -moz-column-gap: 10px;
      column-gap: 10px;

      li {
        margin: 7px 0;

        &:not(:last-child) {
          margin-right: 15px;
        }
      }

      .el-checkbox {
        height: auto;
      }

      .el-checkbox-group {
        .el-checkbox {
          height: 20px;
        }

        .el-checkbox__input .el-checkbox__inner {
          border-color: transparent;
          box-shadow: 0 0 0 1px #ced1d6;
          border-radius: 4px;
          width: 17px;
          height: 17px;
        }

        .el-checkbox__input.is-checked .el-checkbox__inner {
          background: #273480;
          border-color: #ffffff;
          box-shadow: 0 0 0 1px #ced1d6;
          width: 17px;
          height: 17px;
        }

        .el-checkbox__inner::after {
          box-sizing: content-box;
          content: "";
          border: 2px solid var(--el-checkbox-checked-icon-color);
          border-left: 0;
          border-top: 0;
          height: 9px;
          left: 5px;
          position: absolute;
          top: 1px;
          transform: rotate(45deg) scaleY(1);
          width: 3px;
          transition: transform 0.15s ease-in 50ms;
          transform-origin: center;
        }

        .el-checkbox__label {
          color: #34495e;
        }
      }
    }

    .test-group-title {
      font-size: 16px;
      color: #333;
      margin-bottom: 5px;
    }

    .el-dialog {
      width: 50% !important;
      margin-top: 7vh;
    }
  }

  .el-tabs__nav-scroll {
    padding: 0 0 1rem;
    overflow: auto;
    max-height: 200px;
    height: auto;
    width: 100%;
  }

  .el-tabs__nav {
    width: 100% !important;
  }

  .el-tabs .el-tabs__item {
    color: transparent;
    width: 100% !important;
    padding-left: 0 !important;
    font-weight: 500;
    background: transparent;
    margin: 0px;
    height: auto;
    line-height: 30px;
    border-radius: 12.8px;
  }

  .panels-group {
    display: flex;
    flex-wrap: wrap;

    .view-blood-tests {
      &:not(:last-child) {
        .inside {
          margin-right: 30px;
        }
      }
    }
  }

  .view-blood-tests {
    &:not(:last-child) {
      margin-bottom: 10px;
    }

    .view-custom-tabs-label,
    .custom-tabs-label {
      display: block;
    }

    .check-list-woundpanel {
      display: flex;
      flex-wrap: wrap;
      align-content: center;

      li {
        border-radius: 7px;
        padding: 1.5px 10px;
        line-height: 1;
        font-weight: 500;
        display: inline-block;
        font-size: 12.5px;
        color: #273480;
        letter-spacing: 0;
        border: 1px solid rgba(0, 0, 0, 0.05);
        background: #dbdde1;
        margin: 3.5px 0;
        height: fit-content;
        position: relative;

        .el-checkbox-group {
          display: flex;
          flex-wrap: wrap;
        }

        .el-checkbox__input {
          display: none;
        }

        &:not(:last-child) {
          margin-right: 30px;
        }

        .el-checkbox__label {
          color: #273480;
          padding-left: 0;
          font-size: 12.5px;
          font-weight: 500;
        }

        .el-checkbox {
          position: initial;
          height: auto;
        }

        .ellipse {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .el-checkbox__input {
        position: initial;
      }

      .el-checkbox {
        position: initial;
      }
    }
  }

  #sendout-tests {
    li {
      background: #eeebfb;
    }
  }

  .test-close-button {
    padding: 0;
    margin: 0;
    background: none;
    width: 25px;
    height: 25px;
    min-height: auto;
    border: none;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    right: -25px;
    top: 65%;
    transform: translateY(-50%);

    img {
      width: 25px;
    }

    span {
      display: block;
    }
  }
}
</style>
